import React from "react";
import "./Footer.scss";

export const Footer = () => {
  return (
    <div className="footer-container">
      <p className="name">Etienne Thompson</p>
    </div>
  );
};
